"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serialize = serialize;
exports.parseJSON = parseJSON;
exports.isEmpty = exports.noop = void 0;

// ds net util
// @author Pluto <huarse@gmail.com>
// @create 2020/01/03 10:32
const noop = x => x;

exports.noop = noop;

const isEmpty = obj => obj === null || obj === undefined || obj === '';
/**
 * serialize search param
 * @param {object} search search object
 * @param {boolean} [holdEmpty=false] hold empty value
 * @return {string} serialized string
 */


exports.isEmpty = isEmpty;

function serialize(search, holdEmpty) {
  if (typeof search === 'string') return search;
  let str = '';

  for (const key in search) {
    if (Object.prototype.hasOwnProperty.call(search, key)) {
      const value = search[key];
      const empty = isEmpty(value);
      if (!holdEmpty && empty) continue;

      if (Array.isArray(value)) {
        value.forEach(v0 => str += "".concat(key, "%5B%5D=").concat(encodeURIComponent(v0), "&")); // value.forEach(v0 => str += `${key}=${encodeURIComponent(v0)}&`);
      } else {
        str += "".concat(key, "=").concat(empty ? '' : encodeURIComponent(value), "&");
      }
    }
  }

  return str.substring(0, str.length - 1);
}
/**
 * @param {string} jsonStr
 * @return {object}
 */


function parseJSON(jsonStr) {
  if (typeof jsonStr === 'object') return jsonStr;

  try {
    return JSON.parse(jsonStr);
  } catch (ex) {
    console.warn('WARNING: error in parseJSON: ', ex);
    return null;
  }
}